import { Injectable } from "@angular/core";
import { BaseHttpService } from "../base-http.service";
import { UserService } from "../user/user.service";
import { HttpClient } from "@angular/common/http";
import { User, UserAPI } from "../../model";
import { MessageService } from "../../modules/shared/message/message.service";
import { logAnalyticsEvent } from "../../util/analytics.util";
import { ProgressBarService } from "../../modules/shared/progress-bar/progress-bar.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class UserApiService extends BaseHttpService {

  constructor(protected http: HttpClient,
              protected userService: UserService,
              protected translateService: TranslateService,
              protected progressBarService: ProgressBarService,
              protected messageService: MessageService) {
    super(http, userService, translateService, progressBarService, messageService);
  }

  async getUserApis(): Promise<Array<UserAPI>> {
    return (await this.get<Array<UserAPI>>("authenticated/userapis")).result;
  }

  async getUserApisForApi(apiid: number, user: User, isNewUserCombiPackage?: boolean): Promise<Array<UserAPI>> {
    const queryParams = isNewUserCombiPackage !== undefined ? {isNewUserCombiPackage, user} : {user};
    return (await this.get<Array<UserAPI>>(`authenticated/userapis/${apiid}`, queryParams))?.result;
  }

  async testUserApi(userAPI: UserAPI): Promise<boolean> {
    return (await this.post<UserAPI>("authenticated/userapi/test", {userAPI}))?.success;
  }

  async testUserApiNoMessage(userAPI: UserAPI): Promise<string> {
    return (await this.post<string>("authenticated/userapi/testnomessage", {userAPI})).result;
  }

  async testAndSaveUserApi(userAPI: UserAPI, user: User): Promise<UserAPI> {
    const response = await this.post<UserAPI>("authenticated/userapi/testandsave", {userAPI, user});
    if (response.success) {
      // Google Analytics event
			logAnalyticsEvent("account_connected", {userAPIID: response.result?.id});
    }
    return response.result;
  }

  async renameUserApi(userAPI: UserAPI): Promise<void> {
    await this.post("authenticated/userapi/savename", {userAPI});
  }

  async saveCustomConfig1(userAPI: UserAPI): Promise<void> {
    await this.post("authenticated/userapi/savecustomconfig1", {userAPI});
  }

  async delete(userAPI: UserAPI): Promise<void> {
    await this.post("authenticated/userapi/delete", {userAPI});
  }

  async checkScopes(userAPI: UserAPI): Promise<string> {
    return (await this.post<string>("authenticated/userapi/checkscopes", {userAPI})).result;
  }
}
